import { client } from "../../hooks/Client";

// Bouwt de opruimscope die de saveQuestionnaireResponse-functie meekrijgt:
// welke vragen zijn bij deze respondent verborgen en mogen dus geen antwoord
// meer hebben?
//
// De scope draagt de VOLLEDIGE sessiesleutel, zodat de functie hooguit de eigen
// antwoorden van deze respondent kan wissen. Twee invulpaden gebruiken hem
// (losse vraag en gegroepeerde sectie) — één bron, anders lopen ze uiteen.
// AI-CONTEXT: See docs/patterns.md#cf-public-anonymous-callable
// AI-CONTEXT: See docs/features/conditional-questions.md

/**
 * @param {object} args
 * @param {Array<string>} args.hiddenFieldIDs - Vragen die nu verborgen zijn
 * @param {string} args.questionnaireId - Questionnaires doc ID
 * @param {string} args.moment - MomentID url param
 * @param {string} args.research - ResearchID url param
 * @param {string} args.sessionId - Respondent session uuid
 * @returns {object|undefined} De scope, of undefined als er niets op te ruimen valt
 */
const hiddenResponsesScope = ({ hiddenFieldIDs, questionnaireId, moment, research, sessionId }) => {
    const fieldIds = (hiddenFieldIDs || []).filter(Boolean);
    if (fieldIds.length === 0) return undefined;

    return {
        CompagnyID: client,
        SessionID: sessionId,
        QuestionannaireID: questionnaireId,
        MomentID: moment,
        ResearchID: research,
        FieldIDs: fieldIds,
    };
};

export default hiddenResponsesScope;
